<!-- 专题列表 -->
<template>
    <div class="QuestionList">
        <div class="filter_box">
            <van-dropdown-menu>
                <van-dropdown-item :title="quesBankType.name+'-'+param.name + ''" ref="quesBankType">
                    <div class="container">
                        <div class="box" v-for="(obj) in quesBankType.subjectcode" :key="obj.code"
                             :class="[param.subjectcode==obj.id?'selected':'']"  @click="handleChange(obj)">{{obj.name}}</div>
                    </div>
                </van-dropdown-item>
            </van-dropdown-menu>
        </div>
        <div class="ques-body" ref="tabs" :class="{noJoin: !isSubjectJoin}">
            <van-tabs @change="tabChange" v-model="param.sectioncode" animated sticky color="#409EFF" title-active-color="#409EFF"
                      title-inactive-colo="#666666">
                <van-tab name="0101">
                    <template #title><i class="icon-ques" :class="[param.sectioncode == '0101'?'icon-sel-ques1':'icon-ques1']"></i>章节练习 </template>
                    <dataList0101 :param="param" type="0102" :isjoin="isSubjectJoin" ref="dataList0101"></dataList0101>
                </van-tab>
                <van-tab name="0102">
                    <template #title><i class="icon-ques" :class="[param.sectioncode == '0102'?'icon-sel-ques2':'icon-ques2']"></i>历年真题 </template>
                    <dataList0102 :param="param" type="0102" :isjoin="isSubjectJoin" ref="dataList0102"></dataList0102>
                </van-tab>
                <van-tab name="0103">
                    <template #title><i class="icon-ques" :class="[param.sectioncode == '0103'?'icon-sel-ques3':'icon-ques3']"></i>模拟试题 </template>
                    <dataList0103 :param="param" type="0103" :isjoin="isSubjectJoin" ref="dataList0103"></dataList0103>
                </van-tab>
                <van-tab name="0104">
                    <template #title><i class="icon-ques" :class="[param.sectioncode == '0104'?'icon-sel-ques4':'icon-ques4']"></i>易错题 </template>
                    <dataList0104 :param="param" type="0104" :isjoin="isSubjectJoin" ref="dataList0104"></dataList0104>
                </van-tab>
                <van-tab name="0105">
                    <template #title> <i class="icon-ques" :class="[param.sectioncode == '0105'?'icon-sel-ques5':'icon-ques5']"></i>做题记录 </template>
                    <dataList0105 :param="param" type="0105" ref="dataList0105"></dataList0105>
                </van-tab>
            </van-tabs>
        </div>
        <div class="btnBox" v-if="!isSubjectJoin">
            <div class="joinBtn" v-if="topicBaseInfo.feetype === 2" @click="handleClickBuy">
                购买￥{{ topicBaseInfo.uprice1 }}
                <!-- <span class="uprice">￥1280.00</span> -->
            </div>
            <div class="joinBtn" v-if="topicBaseInfo.feetype === 1" @click="handleUploadJoinTopicQuesBank">免费参与</div>
        </div>
        <van-popup v-model="showBuyPopup" position="bottom" round  class="buyPopup">
            <div class="buyPopupTitle">请选择购买的科目，组合购买更加优惠！</div>
            <div class="subjectlist">
                <div class="subjectItem" :class="{active: buySubjectCodeList.indexOf(item.code) !== -1}" @click="handleChoiceSubjectBuy(item)" v-for="(item, index) in topicBaseInfo.subjectlist" :key="index" v-show="topicBaseInfo.joinsubjectcode.indexOf(item.code) == -1">
                    {{ item.name }}
                </div>
            </div>
            <div class="countPrice">
                已选 <span>{{buySubjectCodeList.length}}</span> 门，合计：<span>￥{{ buySubjectCodeList.length ? topicBaseInfo['uprice' + buySubjectCodeList.length] : 0 }}</span>
            </div>
            <div class="nowBuy" @click="handleNowBuy">立即购买</div>
        </van-popup>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import DataList0101 from 'views/mobile/question/components/dataList.vue'
import DataList0102 from 'views/mobile/question/components/dataList.vue'
import DataList0103 from 'views/mobile/question/components/dataList.vue'
import DataList0104 from 'views/mobile/question/components/dataList.vue'
import DataList0105 from 'views/mobile/question/components/dataList.vue'
import {getTopicQBBaseInfo, uploadJoinTopicQuesBank} from 'api/api'
export default {
    name: 'QuestionList',
    data() {
      return {
        quesBankType: {
          code: this.$route.query.code ? this.$route.query.code : 'jjcy',
          name: '',
          subjectcode: []
        },
        param: {
          subjectcode: '',
          sectioncode: '0101',
          examcode: '',
          name: ''
        },
        topicBaseInfo: {},
        isSubjectJoin: false,
        showBuyPopup: false,
        buySubjectCodeList: []
      }
    },
    created() {
      this.topicQuesBankConfiguration.forEach((obj) => {
        if (this.quesBankType.code == obj.code) {
          this.quesBankType.name = obj.name
          this.param.examcode = obj.code
          this.quesBankType.subjectcode = obj.subjectcode
          this.param.subjectcode = obj.subjectcode[0].id
          this.param.name = obj.subjectcode[0].name
          return false
        }
      })
      this.getTopicQBBaseInfo()
    },
    mounted() {
        document.title = '专题题库'
    },
    methods: {
        getTopicQBBaseInfo() {
            this.setLoading(true)
            getTopicQBBaseInfo({
                data: {examcode: this.$route.query.code ? this.$route.query.code : 'jjcy'},
                success: data => {
                    this.buySubjectCodeList = []
                    this.topicBaseInfo = data.data
                    if (this.topicBaseInfo.joinsubjectcode.indexOf(this.param.subjectcode) !== -1) {
                        this.isSubjectJoin = true
                    } else {
                        this.isSubjectJoin = false
                    }
                    if (!this.isSubjectJoin && this.topicBaseInfo.joinsubjectcode.indexOf(this.param.subjectcode) === -1) {
                        this.buySubjectCodeList.push(this.param.subjectcode)
                    }
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        handleChoiceSubjectBuy(item) {
            let i = ''
            this.buySubjectCodeList.some((option, index) => {
                if (option === item.code) {
                    i = index
                    return true
                }
            })
            if (i !== '') {
                this.buySubjectCodeList.splice(i, 1)
            } else {
                this.buySubjectCodeList.push(item.code)
            }
        },
        handleChange(obj) {
            this.param.subjectcode = obj.id
            this.param.name = obj.name
            this.$refs.quesBankType.toggle()
            this.$refs.dataList0101.init()
            if (this.$refs.dataList0102) this.$refs.dataList0102.init()
            if (this.$refs.dataList0103) this.$refs.dataList0103.init()
            if (this.$refs.dataList0104) this.$refs.dataList0104.init()
            if (this.$refs.dataList0105) this.$refs.dataList0105.init()
            this.getTopicQBBaseInfo()
            this.$refs['dataList' + this.param.sectioncode].initList()
        },
        tabChange(obj) {
            this.param.sectioncode = obj
            this.$refs['dataList' + this.param.sectioncode].initList()
        },
        // 点击购买
        handleClickBuy() {
            if (this.user.isLogin) {
                this.showBuyPopup = true
            } else {
                this.$router.push({name: 'MLogin'})
            }
        },
        // 立即购买
        handleNowBuy() {
            if (this.user.isLogin) {
                if (this.buySubjectCodeList.length) {
                    this.$router.push({name: 'MConfirmOrder', query: {qid: this.topicBaseInfo.examcode + '_' + this.buySubjectCodeList.join('_'), kmctype: 8}})
                } else {
                    this.$toast.fail('请选择购买的科目')
                }
            } else {
                this.$router.push({name: 'MLogin'})
            }
        },
        // 免费参与
        handleUploadJoinTopicQuesBank() {
            if (this.user.isLogin) {
                uploadJoinTopicQuesBank({
                    data: {examcode: this.topicBaseInfo.examcode},
                    success: res => {
                        this.$toast.success(res.msg)
                        if (this.$refs.dataList0102) this.$refs.dataList0102.init()
                        if (this.$refs.dataList0103) this.$refs.dataList0103.init()
                        if (this.$refs.dataList0104) this.$refs.dataList0104.init()
                        if (this.$refs.dataList0105) this.$refs.dataList0105.init()
                        this.getTopicQBBaseInfo()
                        this.$refs['dataList' + this.param.sectioncode].initList()
                    },
                    error: res => {
                        this.setLoading(false)
                        this.$toast.fail(res.msg)
                    }
                })
            } else {
                this.$router.push({name: 'MLogin'})
            }
        },
        ...mapActions(['setNoDataTip', 'setLoading'])
    },
    filters: {},
    watch: {},
    computed: {
      ...mapGetters(['topicQuesBankConfiguration', 'domainInfo', 'user'])
    },
    components: {
      DataList0101, DataList0102, DataList0103, DataList0104, DataList0105
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.QuestionList {
    padding-top: 0.8rem;
    .filter_box {
        overflow: hidden;
        background-color: #FFF;
        height: 0.8rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 0.32rem;
        font-size: 0.28rem;
        box-sizing: border-box;
        position: fixed;
        z-index: 999;
        top: 0;
        left: 0;
        right: 0;
        border-bottom: 0.01rem solid #E5E5E5;
        .container{
            max-height: 6.32rem;
            overflow-y: scroll;
        }
        .box{
            padding: 0 0.32rem;
            line-height: 0.8rem;
            height: 0.8rem;
            color: #666;
        }
        .box+.box{
            border-top: 0.01rem solid #E5E5E5;
        }
        .box.selected{
            color:  #409EFF;
            background: #F4FAFF;
        }
        .van-dropdown-menu{
            width: 100%;
            height: 0.8rem;
            background: transparent;
            .van-dropdown-menu__item {
                .van-dropdown-menu__title {
                    display: flex;
                    width: 100%;
                    padding: 0;
                    color: #666666;
                    align-items: center;
                    .van-ellipsis {
                        margin-right: 0.12rem;
                        flex: 1;
                        width: 0;
                    }
                    &::after {
                        position: relative;
                        content: '';
                        border: none;
                        width: 0.24rem;
                        height: 0.24rem;
                        transform: rotate(0deg);
                        background: url('~common/images/mquestion/change_icon.png');
                        background-size: 100% 100%;
                        margin-top: 0;
                    }
                }
            }
            .van-dropdown-menu__bar{
                height: 0.8rem;
                background: transparent;
                box-shadow: 0 0 0 rgba(100,101,102,.08);
                .van-dropdown-menu__item{
                    height: 0.8rem;
                    .van-dropdown-menu__title{
                        padding: 0;
                        width: 100%;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        .van-ellipsis{
                            color: #666;
                        }
                        &:after{
                            position: relative;
                            content: '';
                            border-width: 0;
                            margin-top: 0;
                            width: 0.24rem;
                            height: 0.24rem;
                            background: url("~common/images/mquestion/icon_change.svg") no-repeat 100%;
                            transform: rotate(0);
                        }
                    }
                }
            }
        }
        .van-dropdown-item{
            top: 0.8rem;
        }
    }
    .van-sticky{
        padding-bottom: 0.2rem;
        background: #F5F7FA;
    }
    .van-sticky--fixed{
        top: 0.8rem;
    }
    .ques-body{
        height: calc(100vh - 0.8rem);
        &.noJoin {
            height: calc(100vh - 0.8rem - 1rem - 0.05rem);
        }
        .van-tabs{
            height: 100%;
            .van-sticky{
                .van-tabs__wrap{
                    height: 1.5rem;
                }
            }
            .van-tab{
                width: 1.6rem;
                height: 1.5rem;
                box-sizing: border-box;
                flex-basis: 1.6rem !important;
                .van-tab__text{
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    flex-direction: column;
                    padding: 0.28rem 0;
                    line-height: 1;
                }
                .icon-ques{
                    height: 0.48rem;
                    margin-bottom: 0.16rem;
                    &:before{
                        width: 0.48rem;
                        height: 0.48rem;
                    }
                }
            }
            .van-tab--active{
                box-shadow: 4px 0px 12px 0px rgba(0, 0, 0, 0.1);
            }
            .van-tab + .van-tab{
                border-left: 0.01rem solid #E5E5E5;
            }
            .van-tabs__content {
                height: calc(100% - 1.72rem);
                overflow-y: scroll;
            }
        }
        .van-tabs__line{
            width: 1.5rem !important;
        }
    }
    .btnBox {
        margin-top: 0.05rem;
        height: 1rem;
        background: #ffffff;
        padding: 0.15rem 0.32rem;
        box-sizing: border-box;
        .joinBtn {
            height: 0.7rem;
            background: #409EFF;
            border-radius: 0.38rem;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 0.3rem;
            color: #fff;
            .uprice {
                font-size: 0.26rem;
                margin-left: 0.12rem;
                text-decoration: line-through;
            }
        }
    }
    .van-overlay {
        z-index: 10001 !important;
    }
    .van-popup {
        z-index: 10002 !important;
    }
    .buyPopup {
        padding: 0.3rem 0.32rem 0.32rem;
        box-sizing: border-box;
        .buyPopupTitle {
            font-size: 0.32rem;
            text-align: center;
            font-weight: bold;
            line-height: 0.45rem;
            margin-bottom: 0.4rem;
        }
        .subjectlist {
            padding: 0 0.48rem;
            .subjectItem {
                background: #E5E5E5;
                line-height: 0.7rem;
                text-align: center;
                font-size: 0.3rem;
                color: #333333;
                border-radius: 0.5rem 0 0.5rem 0;
                margin-bottom: 0.32rem;
                &.active {
                    background: #409EFF;
                    color: #fff;
                }
            }
        }
        .countPrice {
            margin: 0.4rem 0 0.2rem;
            line-height: 0.45rem;
            font-size: 0.32rem;
            color: #333333;
            text-align: center;
            span {
                color: #F56C6C;
            }
        }
        .nowBuy {
            height: 0.7rem;
            background: #409EFF;
            border-radius: 0.38rem;
            text-align: center;
            line-height: 0.7rem;
            font-size: 0.3rem;
            color: #fff;
        }
    }
}
</style>